module.exports = __webpack_public_path__ + "img/snakebite-FAQ--1.3a81eab2.jpg";